// 自社情報（請求書の右上ブロックと振込先）の既定値と正規化。純ロジック・DOM非依存。
//
// 設定ドキュメント settings/company。持ち方は settings/labor・settings/display と同じ流儀
// （新テーブル・マイグレーションを作らず、settings 行1件に寄せる）。
// 初期値は実物PDF（エースジャパン/請求データ）の値そのまま。
//
// 未設定・空白だけ・非文字列は**既定へ倒す**（quoteFuel.core / laborQuote.core の先例）。
// 理由: 既定値が実在の自社情報なので、倒した先が常に正しい。逆に空を許すと
// 「自社名の無い請求書」を取引先へ送れてしまう。

export const DEFAULT_COMPANY = {
  name: 'エースジャパン株式会社',
  tnum: 'T-5130001045290',
  zip: '6190238',
  address: '京都府相楽郡精華町精華台五丁目1番1',
  tel: '0774-46-8987',
  fax: '0774-46-8988',
  bank1: 'りそな銀行　新奈良営業部　普通　0371604　エースジャパン（カ',
  bank2: '京都銀行　　高の原支店　　普通　0140355　エースジャパン（カ',
}

export const COMPANY_FIELDS = [
  ['name', '自社名'], ['tnum', '登録番号'], ['zip', '〒'], ['address', '住所'],
  ['tel', 'TEL'], ['fax', 'FAX'], ['bank1', '振込先1'], ['bank2', '振込先2'],
]

const str = (v) => (typeof v === 'string' ? v.trim() : '')

/** settings/company ドキュメント → 自社情報。未設定・不正値は既定へ倒す。未知のキーは持ち込まない。 */
export function resolveCompany(doc) {
  const out = {}
  for (const [k] of COMPANY_FIELDS) out[k] = str(doc && doc[k]) || DEFAULT_COMPANY[k]
  return out
}

// ---- 得意先の 〒/住所/TEL/FAX（customers マスタへ追加したフィールド） ----
export const CUSTOMER_FIELDS = [
  ['zip', '〒'], ['addr1', '住所'], ['addr2', '住所2（任意）'], ['tel', 'TEL'], ['fax', 'FAX'],
]

/** customers ドキュメント → 請求書の宛先ブロック。**無ければ空文字**（既定へ倒さない）。 */
export function resolveCustomerInfo(doc) {
  return { zip: str(doc && doc.zip), addr1: str(doc && doc.addr1), addr2: str(doc && doc.addr2), tel: str(doc && doc.tel), fax: str(doc && doc.fax) }
}

/** 未登録の項目名。空欄で刷るのは許すが、画面では黙らない（住所2 は任意なので対象外）。 */
export function missingCustomerFields(info) {
  return [['zip', '〒'], ['addr1', '住所'], ['tel', 'TEL'], ['fax', 'FAX']].filter(([k]) => !info || !info[k]).map(([, l]) => l)
}
